import React from "react"

import { TestCaseTable } from "./TestCaseTable"

/**
 * Main container for the test case list
 * All child components access TestSetEditorContext directly
 */
export const TestCaseList: React.FC = () => {
  return (
    <div className="flex flex-col min-h-full">
      <div className="flex-1">
        <TestCaseTable />
      </div>
    </div>
  )
}
